'use strict';

var _ = require('lodash');
var FaresOptimizerAnalysisDataUtilsService = function FaresOptimizerAnalysisDataUtilsService(App, configurationService, faresOptimizerConstants) {
  var ENTRY_LEVEL_ONLY_FIELDS = ['season', 'dow', 'status', 'compFareSource', 'compCarrier', 'compTripType', 'compMarketFbc', 'compFare', 'compFootnote', 'compFareBrandName', 'lastUpdated'];
  var COMPETITOR_FIELDS = ['compFareSource', 'compCarrier', 'compTripType', 'compMarketFbc', 'compFare', 'compFootnote', 'compFareBrandName'];
  var DISPLAY_FIELD_PREFIX = 'display';
  function getDisplayField(fieldName) {
    return DISPLAY_FIELD_PREFIX + _.upperFirst(fieldName);
  }
  function getGroupKey(item, configName) {
    var splitMarket = item.market.split('-');
    return [configName, splitMarket[0], splitMarket[1], item.cabin, item.category].join('.');
  }
  function getGroupingForKey(grouping, key) {
    return grouping && grouping[key];
  }
  function matchToGroup(item, matchProperty, start, end) {
    return _.inRange(item[matchProperty], start, end + 1);
  }
  function formatGroup(group, startProp, endProp) {
    return [group[startProp], group[endProp]].join(' - ');
  }
  function assignGroup(item, assignParams) {
    var groupingConfig = configurationService.getFoGrouping(assignParams.configName);
    var key = getGroupKey(item, assignParams.configName);
    var matchingConfig = getGroupingForKey(groupingConfig, key);
    if (matchingConfig) {
      var applicableGroup = _.chain(matchingConfig).filter(function (grouping) {
        return matchToGroup(item, assignParams.matchProperty, grouping[assignParams.startProp], grouping[assignParams.endProp]);
      }).first().value();
      if (applicableGroup) {
        item[assignParams.groupName] = formatGroup(applicableGroup, assignParams.startProp, assignParams.endProp);
      } else {
        item[assignParams.groupName] = 'None';
      }
    } else {
      item[assignParams.groupName] = '-';
    }
    return item;
  }
  function convertDayOfWeekNumber(dow) {
    var weekday = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
    var daysOfWeek = ['-', '-', '-', '-', '-', '-', '-'];
    if (dow !== undefined && dow) {
      var dayOfWeekNumber = dow.split('');
      for (var i = 0; i < dayOfWeekNumber.length; i++) {
        var dayOfWeek = parseInt(dayOfWeekNumber[i]);
        daysOfWeek[dayOfWeek - 1] = weekday[dayOfWeek - 1];
      }
    } else {
      return weekday.join('');
    }
    return daysOfWeek.join('');
  }
  function convertDayOfWeekCharacter(dow) {
    var dowCharacters = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
    var counter = 0;
    var dowNumbers = [];
    if (!_.isNil(dow) && dow.length === dowCharacters.length) {
      var inputDowCharacters = dow.split('');
      _.each(inputDowCharacters, function (character) {
        counter += 1;
        if (isDowCharacter(dowCharacters, character)) {
          dowNumbers.push(counter);
        }
      });
    }
    return dowNumbers.join('');
  }
  function isDowCharacter(dowCharacters, character) {
    return dowCharacters.indexOf(character) !== -1;
  }
  function assignMinMaxStayGrouping(item) {
    assignGroup(item, {
      configName: 'FOMaxStayGrouping',
      groupName: 'maxStayGroup',
      matchProperty: 'maxStay',
      startProp: 'maxStayStart',
      endProp: 'maxStayEnd'
    });
    assignGroup(item, {
      configName: 'FOMinStayGrouping',
      groupName: 'minStayGroup',
      matchProperty: 'minStay',
      startProp: 'minStayStart',
      endProp: 'minStayEnd'
    });
    item.mmsGroup = [item.minStayGroup, item.maxStayGroup].join('/');
    return item;
  }
  function assignAdvancePurchaseGrouping(item) {
    return assignGroup(item, {
      configName: 'FOAdvancePurchaseGrouping',
      groupName: 'apGroup',
      matchProperty: 'advancePurchase',
      startProp: 'advancePurchaseStart',
      endProp: 'advancePurchaseEnd'
    });
  }
  function getSeasonCharacterPosition() {
    return configurationService.getFoFareBasisCodeSeasonPosition();
  }
  function getSeasonCodeFromFbc(fareBasisCode) {
    return fareBasisCode.charAt(getSeasonCharacterPosition() - 1);
  }
  function getSeasonDefinition(seasonIndicator, fbc) {
    var seasonAbbreviationMap = getFoSeasonAbbreviationMap();
    return configurationService.getFoUseSeasonIndicator() === 'Y' ? seasonAbbreviationMap[seasonIndicator] : seasonAbbreviationMap[getSeasonCodeFromFbc(fbc)];
  }
  function getFoSeasonAbbreviationMap() {
    var seasonDefinitions = configurationService.getFoSeasonDefinitions();
    return _.reduce(seasonDefinitions, function (result, seasonDefinition) {
      result[seasonDefinition.seasonAbbreviation] = seasonDefinition.season;
      return result;
    }, {});
  }
  function addEntryLevelDisplayFields(item) {
    if (item.groupingStartRow) {
      _.forEach(ENTRY_LEVEL_ONLY_FIELDS, function (field) {
        item[getDisplayField(field)] = item[field];
      });
    }
    _.forEach(COMPETITOR_FIELDS, function (field) {
      item[getDisplayField(field)] = item[field];
    });
  }
  function assignGridDisplayFields(item) {
    addEntryLevelDisplayFields(item);
    return item;
  }
  function assignCustomClasses(item) {
    item.customRowClasses = [_.lowerCase(item.status).replace(/\s/g, '')];
    if (item.isEntryLevel) {
      item.customRowClasses.push('entry-level');
    }
    if (item.isLinkedFbc) {
      item.customRowClasses = ['linked-fbc'];
    } else if (item.isDualRbdFare) {
      item.customRowClasses = ['dual-rbd'];
    }
    item.customCellClasses = {};
    item.customGroupHeaderCellClasses = {};
    return item;
  }
  function assignCustomClassForSelectedCompetitor(item) {
    if (item.isCompetitor) {
      item.customRowClasses = ['selected-competitor'];
    }
  }
  function getExpectedSponsorFbc(recommendation) {
    return recommendation.origin + '.' + recommendation.destination + '.' + recommendation.fareBasisCode;
  }
  function getExpectedSponsorMarket(recommendation) {
    return recommendation.origin + '.' + recommendation.destination;
  }
  function isSponsorMarketFbc(recommendationLadder, recommendation) {
    return _.find(recommendationLadder.fareRecommendationList, {
      sponsorMarketFbc: getExpectedSponsorFbc(recommendation)
    }) !== undefined || _.find(recommendationLadder.fareRecommendationList, {
      sponsorMarketFbc: getExpectedSponsorMarket(recommendation)
    }) !== undefined;
  }
  function getLinkedFbc(recommendationLadder, recommendation) {
    var linkedRecommendations = getLinkedRecommendations(recommendationLadder, recommendation, [], []);
    return _.map(linkedRecommendations, function (recom) {
      return _.pick(recom, ['origin', 'destination', 'fareBasisCode']);
    });
  }
  function getLinkedRecommendations(recommendationLadder, recommendation, linkedRecommendations, visitedMarkets) {
    var linkedRec;
    var key = recommendation.origin + '.' + recommendation.destination;
    if ('TACTICAL' === recommendationLadder.category) {
      if (visitedMarkets.indexOf(key) === -1) {
        linkedRec = _.filter(recommendationLadder.fareRecommendationList, {
          sponsorMarketFbc: getExpectedSponsorMarket(recommendation)
        });
        visitedMarkets.push(key);
      }
    } else {
      key = key + '.' + recommendation.fareBasisCode;
      if (visitedMarkets.indexOf(key) === -1) {
        linkedRec = _.filter(recommendationLadder.fareRecommendationList, {
          sponsorMarketFbc: getExpectedSponsorFbc(recommendation)
        });
        visitedMarkets.push(key);
      }
    }
    _.forEach(linkedRec, function (linkedRecommendation) {
      linkedRecommendations.push(linkedRecommendation);
      getLinkedRecommendations(recommendationLadder, linkedRecommendation, linkedRecommendations, visitedMarkets);
    });
    return linkedRecommendations;
  }
  function getFareBrandInfo(carrier, fareBrand) {
    if (_.isNil(fareBrand)) {
      return getEmptyFareBrand();
    }
    var fareBrands = _.find(configurationService.getFoFareBrandDefinitions(), {
      carrier: carrier
    });
    if (!fareBrands) {
      return getEmptyFareBrand();
    }
    var fareBrandDefinition = _.find(fareBrands.fareBrands, {
      fareBrand: fareBrand
    });
    if (!fareBrandDefinition) {
      return getEmptyFareBrand();
    }
    return {
      fareBrand: fareBrandDefinition,
      fareBrandName: fareBrandDefinition.fareBrand
    };
  }
  function getEmptyFareBrand() {
    return {
      fareBrand: faresOptimizerConstants.EN_DASH,
      fareBrandName: faresOptimizerConstants.EN_DASH
    };
  }
  return {
    convertDayOfWeekNumber: convertDayOfWeekNumber,
    convertDayOfWeekCharacter: convertDayOfWeekCharacter,
    assignMinMaxStayGrouping: assignMinMaxStayGrouping,
    assignAdvancePurchaseGrouping: assignAdvancePurchaseGrouping,
    getSeasonDefinition: getSeasonDefinition,
    assignGridDisplayFields: assignGridDisplayFields,
    assignCustomClasses: assignCustomClasses,
    assignCustomClassForSelectedCompetitor: assignCustomClassForSelectedCompetitor,
    isSponsorMarketFbc: isSponsorMarketFbc,
    getLinkedFbc: getLinkedFbc,
    getFareBrandInfo: getFareBrandInfo
  };
};
FaresOptimizerAnalysisDataUtilsService.$inject = ['App', 'ConfigurationService', 'FaresOptimizerConstants'];
module.exports = FaresOptimizerAnalysisDataUtilsService;